
/* injects from baggage-loader */

'use strict';

import InvestorDocumentModalController from './investordocumentmodal.controller';
import InvestorDocumentModalTemplate from './investordocumentmodal.html';

export default class InvestorDocumentModalComponent {
		constructor() {
				this.templateUrl = InvestorDocumentModalTemplate;
				this.controller = InvestorDocumentModalController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = {
					resolve: '<',
					close: '&',
					dismiss: '&'
				};
		}
}
